import React from 'react'
import PropTypes from 'prop-types'

import { CLOUDFLARE_IMAGE_IDS } from '~/constants'
import { getCloudflareImageURL } from '~/utils'
import VisitorData from '~/services/fingerprint/VisitorData'

const SignUpV3RegistrationHeader = props => {
  const { isMobile } = props

  return (
    <>
      {isMobile ? (
        <img
          src={getCloudflareImageURL(CLOUDFLARE_IMAGE_IDS.STELLAR_LOGO_HORIZONTAL)}
          alt="stellarfi logo"
          className="w-36 h-10 text-center mx-auto mb-7"
        />
      ) : null}
      <h3 className="font-bold text-2xl mb-4 text-center">
        Automatically raise your credit score with StellarFi
      </h3>
      <VisitorData tag="signup" />
    </>
  )
}

SignUpV3RegistrationHeader.propTypes = {
  isMobile: PropTypes.bool.isRequired,
}

const Memoized = React.memo(SignUpV3RegistrationHeader)
export default Memoized
